<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-08-24 15:03:50
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-27 18:10:10
 * @FilePath: /goldenSalesMobile/src/views/InvitePoster/index.vue
 * @Description: 邀请注册分销员界面
-->
<template>
  <div class='page-container'>
    <div class="invite-qrCode">
      <vue-qr :logoSrc="codeLogoSrc" :text="inviteQrCodeText" :size="200" />
    </div>
    <g-copy-right />
  </div>
</template>

<script>
export default {
  data() {
    return {
      distributorId: this.$route.query.id,
      headId: this.$route.query.headId,
      inviteQrCodeText: '',
      codeLogoSrc: ''
    }
  },
  created() {
    this.inviteQrCodeText = `${location.href.split('#/')[0]}#/register-saler?id=${this.distributorId}&headId=${this.headId}` 
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    position: relative;
    width: 100%;
    height: 100vh;
    background: url('../../assets/common_image/invite_bg.png') no-repeat center;
    background-size: 100%;

    .invite-qrCode {
      position: absolute;
      left: 178px;
      top: 408px;
      z-index: 1;
      width: 388px;
      height: 388px;
    }

    .g-copy-right {
      opacity: 49%;
    }
  }
</style>
